'use strict';
/**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/units/:unitId', null, {
            getAll: {method: 'GET'},
            get: {method: 'GET'},
            create: {method: 'POST'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            enable: {url: 'api/units/:unitId/enable', method: 'PUT'},
            delete: {url: 'api/units/:unitId/delete', method: 'PUT'},
            // getDefault: {url: 'api/units/default', method: 'GET'},
            // setDefault: {url: 'api/units/:unitId/default', method: 'PUT'},
            isUniqueName: {url: 'api/units/unique/name/:name', method: 'GET'},
            // exists: {url: 'api/units/exists', method: 'GET'}
        });
    }];